import { httpClient } from '../http-client';
import { GateHours, GateHoursDailyOverride } from './types';

export const gateHoursService = () => {
  const client = httpClient();
  const BASE_URL = '/v1/gate-hours';

  return {
    fetchGateHours: async (terminal: string): Promise<GateHours | null> => {
      const url = `${BASE_URL}/${terminal}`;
      try {
        const result = await client.get<GateHours>(url);
        return result.data;
      } catch (e) {
        logger(`Error calling API: ${e}`);
        return null;
      }
    },
    updateWeatherParam: async (data: GateHours): Promise<GateHours | null> => {
      try {
        const result = await client.post<GateHours>(BASE_URL, data);
        return result.data;
      } catch (e) {
        logger(`Error calling API: ${e}`);
        return null;
      }
    },
    fetchDailyOverride: async (terminal: string): Promise<GateHoursDailyOverride[] | null> => {
      const url = `${BASE_URL}/${terminal}/daily-overrides`;
      try {
        const result = await client.get<GateHoursDailyOverride[]>(url);
        return result.data;
      } catch (e) {
        logger(`Error calling API: ${e}`);
        return null;
      }
    },
    updateDailyOverride: async (
      terminal: string,
      data: GateHoursDailyOverride[],
    ): Promise<GateHoursDailyOverride[] | null> => {
      const url = `${BASE_URL}/${terminal}/daily-overrides`;
      try {
        const result = await client.post<GateHoursDailyOverride[]>(url, data);
        return result.data;
      } catch (e) {
        logger(`Error calling API: ${e}`);
        return null;
      }
    },
  };
};

const logger = (message: string): void => console.error(`[Gate Hours Service] ${message}`);
